import PropTypes from 'prop-types';

export const invisibleReCaptchaPropTypes = { onValidation: PropTypes.func.isRequired };

export const reCaptchaPropTypes = { onChange: PropTypes.func.isRequired };
